import { Age } from '~/directives/age'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('age', Age)
})
